import { Round as PlayArrowIcon } from '@manomano-internal/tamagoshi-icons/esm/material/PlayArrow';
import classnames from 'classnames';
import type { FC } from 'react';

import styles from './DotsController.module.scss';

interface Props {
  currentSlide: number;
  numberOfImages: number;
  numberOfVideos: number;
  className?: string;
}

export const DotsController: FC<Props> = ({
  className,
  currentSlide,
  numberOfVideos,
  numberOfImages,
}) => {
  if (numberOfImages + numberOfVideos < 2) return null;

  const videosDummyArray = Array.from({ length: numberOfVideos }, (_, i) => i);
  const rootClassName = classnames(styles.root, className);
  return (
    <div className={rootClassName} data-testid="sliderDots">
      {Array.from({ length: numberOfImages }).map((_, i) => (
        <div
          className={classnames(styles.dot, {
            [styles.active]: currentSlide === i,
          })}
          // eslint-disable-next-line react/no-array-index-key
          key={`slide-${i}`}
        />
      ))}
      {videosDummyArray.map((videoIndex) => (
        <PlayArrowIcon
          className={classnames(styles.play, {
            [styles.active]: currentSlide === numberOfImages + videoIndex,
          })}
          key={videoIndex}
        />
      ))}
    </div>
  );
};

DotsController.displayName = 'DotsController';
